import { useQuery } from '@tanstack/react-query';

import { post } from 'src/utils/helpers/http';
import { PaymentType } from 'src/app/types/payments';
import { useBaseAPIParams } from 'src/utils/hooks/useBaseAPIParams';

export const endpoints = {
  GET_PAYMENT_INTEGRATIONS_POS: 'generipay/get-payment-integrations-pos',
};

export const generiPayQueryKey = 'generipay-payment-integrations-pos';

export type GeneriPayGiftCardSettings = {
  GiftCardMaxLength: number;
  GiftCardMinLength: number;
};

export type GeneriPayPaymentIntegration = {
  CamelizedIntegrationType: string;
  IntegrationType: string;
  Name: string;
  PosButtonText: string;
  PosReportingField: string;
  PosReportingFieldId: number;
  PaymentCaptureFields: string[];
  PaymentIntegrationDefinitionId: string;
  GiftCardSettings?: GeneriPayGiftCardSettings;
  Cancellable: boolean;
  UseCartSync: boolean;
};

export function useGeneriPayPaymentIntegrationsPOSQuery(RegisterId?: number, generiPayEnabled: boolean = false) {
  const baseAPIParams = useBaseAPIParams();

  return useQuery({
    queryKey: [generiPayQueryKey, RegisterId],
    queryFn: async () => {
      return await post<GeneriPayPaymentIntegration[]>(endpoints.GET_PAYMENT_INTEGRATIONS_POS, { 
        ...baseAPIParams,
        RegisterId 
      });
    },
    enabled: generiPayEnabled,
  });
} 